// tslint:disable: quotemark
export enum PermissionProfile {
	SiteUser = 0,
	SiteManager = 1,
	OrganizationAdmin = 2,
	SystemAdmin = 3
}

export namespace PermissionProfile {
	export function toDescription(val: PermissionProfile) {
		switch (val) {
			case 0:
				return "Site User";
			case 1:
				return "Site Manager";
			case 2:
				return "Organization Admin";
			case 3:
				return "Admin";
		}
		return null;
	}
}
